import { gql } from "@apollo/client";
import { useCallback } from "react";
import { useMutation } from "@apollo/client/react";

import { clearStoredToken } from '../../apollo/client';

import type { LogoutResp } from '../../types/logoutTypes';

const LOGOUT = gql`
  mutation Logout {
    logout {
      success
      errors
    }
  }
`   

type UseLogoutOptions = {
  onCompleted?: (success: boolean) => void;
  onError?: (error: unknown) => void;
  mutationOptions?: Parameters<typeof useMutation<LogoutResp>>[1];
};

const useLogout = (options?: UseLogoutOptions) => {
  const [mutate, { data, loading, error }] = useMutation<LogoutResp>(LOGOUT, options?.mutationOptions);

  const logout = useCallback(
    async () => {
      try {
        const result = await mutate();

        const logout = result?.data?.logout;

        if (logout?.errors?.length) {
          if (logout.errors.includes('User was not found or was not logged in.')) {
            clearStoredToken();
            return window.location.href = '/';
          }
          throw new Error(logout.errors.join(", "));
        }

        if (options?.onCompleted && logout?.success) {
          options.onCompleted(logout.success);
        }

        return logout?.success;
      } catch (err) {
        if (options?.onError) {
          options.onError(err);
        }
        throw err;
      }
    },
    [mutate, options]
  );

  const success = data?.logout?.success;

  return {
    logout,
    success,
    loading,
    error: error as Error | null | undefined,
  };
}

export default useLogout
